module.exports = __webpack_public_path__ + "fonts/south_afirkas_ 2100.f8e57447.ttf";